export default __webpack_public_path__ + "static/media/is.16e94bb2.svg";